module.exports = __webpack_public_path__ + "static/img/businessCard.14f61f1e.png";